<template>
  <div id="app">
    <div v-if="readyStateComplete">
          <router-view/>
    </div>
    <div class="pt-5 mt-5" v-else>
      <img src="https://images.avishkaar.cc/workflow/hp_v1/loader_new.gif" alt="">
    </div>
  </div>
</template>
<script>
export default {
  data(){
    return {
      readyStateComplete: false
    }
  },
  mounted() {
    document.onreadystatechange = () => {
      if (document.readyState == "complete") {
        console.log('Page completed with image and files!')
        this.readyStateComplete = true

      }
    }
  },
}
</script>
<style>
/* @import url('https://use.fontawesome.com/releases/v5.4.2/css/all.css'); */
body {
  font-family: Roboto !important;
  background: white;
  scroll-behavior: smooth;
}
p {
  font-family: Roboto;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
h1,
h2,
h3,
h4,
h5 {
  font-family: "Poppins", sans-serif !important;
  color: #303030 !important;
}
h3 {
font-weight: 600;
font-size: 32px !important;
line-height: 48px;
letter-spacing: 0.005em;
}
a:hover {
  text-decoration: none !important;
}
.box .inputBox {
  position: relative;
}

.box .inputBox input {
  font-size: 1rem;
  letter-spacing: 0.062rem;
  border: 1px solid rgba(25, 25, 25, 0.32);
  border-radius: 5px;
  opacity: 1;
  background: transparent;
}

.box .inputBox label {
  position: absolute;
  top: 12px;
  left: 30px;
  padding: 0.625rem 0;
  font-size: 15px;
  pointer-events: none;
  transition: 0.5s;
  letter-spacing: 0;
  color: #bfbfbf;
  opacity: 1;
}
.box .phone_box label {
  left: 55px !important;
}
.box .common_field label {
  left: 45px !important;
}
.welcome_check {
  font-size: 15px;
  color: #707070;
  opacity: 1;
}
.welcome_check input[type="checkbox"] {
  background: red;
}
.box .inputBox input:focus ~ label,
.box .inputBox input:not([value=""]) ~ label {
  top: -0.5rem;
  left: 30px;
  font-size: 0.75rem;
  background-color: white;
  height: 10px;
  padding: 0 8px 20px 8px;
}
.box .inputBox input:focus {
  outline: none;
  border: 1px solid #ff7033;
}
.box .inputBox input:focus ~ label,
.box .phone_box input:focus ~ label {
  color: #ff7033 !important;
}
.ab-btn {
  background: #F36F2E;
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.12);
  border: 1px solid #f36f2e;
  box-sizing: border-box;
  border-radius: 30px;
  color: white;
  font-weight: 500;
  font-size: 16px;
  font-family: Roboto;
  padding: 10px 30px;
}
.ab-success-btn-cart,
.ab-success-btn-cart:hover {
  background: #FFFFFF;
  border: 1px solid #E0E0E0;
  box-sizing: border-box;
  border-radius: 24px;
  color: #9BC157;
  font-size: 16px;
  font-weight: 500;
  font-family: Roboto;
  padding: 10px 30px;
}
.ab-btn:hover {
    color: white;
    text-decoration: none;
}
.ab-btn-disbale {
  background: grey !important;
  border: 1px solid grey !important;
}
.ab-btn-border {
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.12);
  border: 1px solid #f36f2e;
  box-sizing: border-box;
  border-radius: 30px;
  color: #F36F2E;
  font-weight: 500;
  font-size: 16px;
  font-family: Roboto;
  padding: 10px 30px;
  background: transparent;
}
.ab-btn-cart {
background: #FFFFFF;
border: 1px solid #CBD2D7;
box-sizing: border-box;
border-radius: 30px;
color: #606060;
  font-weight: 500;
  font-size: 16px;
  font-family: Roboto;
  padding: 10px 30px;
  background: transparent;
}
.ab-btn-none {
  border: none;
  background: none;
}

.custom-faq,
.card-header{
    background: transparent !important;
    border: none !important;
    color: #303030 !important;
    font-weight: 800 !important;
    text-align: left !important;
    border: none !important;
    outline: none !important;
    box-shadow: none !important;
}
.faq-desc {
    color: rgba(48, 48, 48, 0.5);
    font-size: 14px;
    line-height: 21px;
}
.accordion .card {
    border-left: none;
    border-right: none;
    border-color: #E0E0E0;
}
.accordion .card:first-child {
    border-top: none;
}
.accordion .card-body {
    padding-top: 0px;
}
.custom-faq[aria-expanded="true"]:after {
  font-family: "Font Awesome 5 Free"; font-weight: 600; content: "\f068";color: #606060;
}
.custom-faq:after {
      font-family: "Font Awesome 5 Free"; font-weight: 600; content: "\f067";margin-left: auto;color: #606060;
}
.accordion .card {
    border-left: none;
    border-right: none;
    border-color: #E0E0E0;
}
.accordion .card:first-child {
    border-top: none;
}
.accordion .card-body {
    padding-top: 0px;
}
.custom_disbale {
background: #E0E0E0 !important;
color: #8B8B8B !important;
  border: 1px solid #E0E0E0 !important;
}
</style>
